import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, FileText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { INSTRUMENTS } from "@/data/curriculum";
import { theoryChecks } from "@/lib/theory";
import { api } from "@/lib/api";

export const TheoryStars = () => {
  const { purchases } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/theory/status").then(({ data }) => setSt(data)).catch(() => {}); }, []);
  const rows = INSTRUMENTS.flatMap((inst) => inst.courses.map((c) => ({ inst, c, key: `${inst.id}:${c.id}` }))).filter((r) => (purchases || []).includes(r.key));
  if (!st || rows.length === 0) return null;
  return (
    <section className="mt-10" data-testid="theory-stars">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">Theory stars</p>
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        {rows.map(({ inst, c, key }) => {
          const need = theoryChecks(c);
          const got = need.filter((id) => (st.checks[key] || []).includes(id)).length;
          const star = got >= need.length && need.length > 0;
          const paper = st.papers[key];
          return (
            <div key={key} className={`rounded-2xl border p-4 ${star ? "border-primary/60 bg-primary/10" : "border-border bg-card"}`} data-testid={`theory-star-${key}`}>
              <div className="flex items-center gap-3">
                <Star size={22} className={star ? "fill-primary text-primary" : "text-muted-foreground"} />
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-foreground">{inst.label} · {c.tagline}</p>
                  <p className="text-xs text-muted-foreground">{star ? "Theory Star earned!" : `${got}/${need.length} theory checks passed`}</p>
                </div>
              </div>
              <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-secondary"><div className="h-full bg-primary transition-[width]" style={{ width: `${need.length ? (got / need.length) * 100 : 0}%` }} /></div>
              <Link to={`/practice-paper/${inst.id}/${c.id}`} className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-primary hover:underline" data-testid={`theory-paper-link-${key}`}>
                <FileText size={13} /> Practice paper{paper ? ` · best ${paper.best}/${paper.total}` : ""}
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};
